import InfantMeatsProduct from 'models/InfantMeatsProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import InfantMeatsPackage from './InfantMeatsPackage'
import { packagingInitialState, brandNameOptions } from './constants'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc initialBrandNameOptions={brandNameOptions} />
  ),
  packagingInfo: (
    <InfantMeatsPackage
      model={InfantMeatsProduct}
      packagingInitialState={packagingInitialState}
    />
  ),
  productTitle: 'Infant Meats',
  model: InfantMeatsProduct,
  validCategories: ['13'],
  validSubCategories: ['001', '101'],
}

const InfantMeats = () => <ProductForm product={productOptions} />

export default InfantMeats

export const getInfantMeatsPackage = newProduct => {
  let newInfantMeatsPackage = {
    UPC: newProduct.UPC,
    PackageType: newProduct.PackageType,
    PacketSize: newProduct.PacketSize,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newInfantMeatsPackage.MultiPackageCount = newProduct.MultiPackageCount
  }
  return newInfantMeatsPackage
}
export const updateInfantMeatsPackage = newProduct => {
  let newInfantMeatsPackage = {
    UPC: newProduct.UPC,
    PackageType: newProduct.PackageType,
    PacketSize: newProduct.PacketSize,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newInfantMeatsPackage.MultiPackageCount = newProduct.MultiPackageCount
  }
  return newInfantMeatsPackage
}
